import { disneyEspnVS } from './espn/vs-unified';
import { disneyAvailableNow } from './available-now';
import { disneyCTV } from './ctv';
import { disneySeasonality } from './seasonality';
import { disneyEspnPlayerVSPlayer } from './espn/player-vs-player';
import { disneyEspnHero } from './espn/espn-heros';
import { disneyESPNTextuales } from './espn/textuales';
import { disneyESPNLogoVsLogo } from './espn/logo-vs-logo';

export const DISNEY_TEMPLATES = [
  disneyESPNLogoVsLogo,
  disneyESPNTextuales,
  disneyEspnHero,
  disneyAvailableNow,
  disneyCTV,
  disneyEspnVS,
  disneySeasonality,
  disneyEspnPlayerVSPlayer
] as const;

export * from './espn/vs-unified/';
export * from './available-now';
export * from './ctv';
export * from './seasonality';
export * from './proximamente/social-this-month.config';
export * from './proximamente/related.config';
export * from './proximamente/social-top.config';
export * from './proximamente/cast.config';
export * from './proximamente/grid.config';
export * from './proximamente/binge.config';
export * from './proximamente/best-plan.config';
export * from './espn/player-vs-player';
export * from './espn/espn-heros';
export * from './espn/textuales';
export * from './espn/logo-vs-logo';
